export default "__VITE_ASSET__BrLfGMhP__"